import React from 'react';
import classNames from 'classnames';

const ScheduleTableRows = ({ Schedule }) => {
  const Day = Schedule.Day;
  const OpeningTimes = Schedule.Spans;

  const Rows = OpeningTimes && OpeningTimes?.map((item, index) => (
    <tr className="schedule-table__row" key={index}>
      {Day && (
        <td
          className={classNames({
            "schedule-table__data": true,
            "schedule-table__day": true,
            'show-for-sr': index > 0,
          })}
        >
          {Day}
        </td>
      )}
      {item.Period && (
        <td className="schedule-table__data schedule-table__item__period">
          {item.Period}
        </td>
      )}
      {item.Comment && (
        <td className="schedule-table__data schedule-table__item__comment">
          {item.Comment}
        </td>
      )}
    </tr>
  ));

  return Rows;
};

export default ScheduleTableRows;
